import axios from 'axios';

export default {
  createQuote: data => {
    return axios.post('crear/cotizacion', data);
  },
  addItemsQuote: data => {
    return axios({
      url: 'agregar/items/cotizacion',
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  getProductsList(parameter) {
    if (parameter != null) {
      return axios.get('buscar/productos?query=' + parameter);
    } else {
      return axios.get('buscar/productos');
    }
  },

  getTextList(parameter) {
    if (parameter != null) {
      return axios.get('buscar/textos?query=' + parameter);
    } else {
      return axios.get('buscar/textos');
    }
  },

  getQuoteDetails(idQuote) {
    return axios.get('detalle/cotizacion/' + idQuote);
  },

  updateQuote(idQuote, data) {
    data.append('_method', 'PUT');
    return axios.post(`/cotizaciones/${idQuote}`, data);
  },

  deleteAttatchement(attachment, type, id) {
    return axios.delete(
      'eliminar/adjunto?attachment=' + attachment + '&type_item=' + type + '&id=' + id
    );
  },

  sendMailQuotation(data) {
    return axios.post('enviar/cotizacion', data);
  },

  sendMailReminder(data) {
    return axios.post('enviar/recordatorio', data);
  },

  getQuoteDataForClient(token, data) {
    return axios.post('detalle/cotizacion/cliente/' + token, data);
  },

  updateTotal(data, idQuote) {
    return axios.post('guardar/total/' + idQuote, data);
  },

  deleteQuote(quotationUuid, itemid) {
    return axios.delete(`/cotizaciones/${quotationUuid}/items/${itemid}`);
  }
};
